var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},[_c('apexchart',{attrs:{"type":_vm.type,"height":_vm.height,"options":_vm.chartOptions,"series":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }